import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  list: [],
  total_list: 0,
  isUploading: false,
  pagination: { num_page: 0, num_items: -1 },
  current_filters: {},
  punishment_events: [],
};

// getters
const getters = {
  getList: (state, getters, rootState, rootGetters) => id => {
    if (state.total_list == 0) return [];

    var categories = rootGetters["events/getCategoriesEventSelected"]();
    if (typeof id !== "undefined") return state.list[id];

    var data = [];
    for (var c in categories) {
      var category = categories[c];
      category.type = "category";
      data.push(category);
      for (var k in state.list) {
        var player = state.list[k];
        if (player.category_id == category.id) {
          data.push(player);
        }
      }
    }
    return data;
  },

  getListNoFiltered: (state, getters, rootState) => type => {
    var aClubs = [];
    for (var i in state.list) {
      if (state.list[i].visible) aClubs.push(state.list[i]);
    }
    return aClubs;
  },

  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  },

  getPunishmentEvents: (state) => () => {
    return state.punishment_events
  }
};

// actions
const actions = {
  loadList(
    { commit, dispatch, getters, rootState, state, rootGetters },
    params
  ) {
    return api
      .get("competition/sanctions/event/" + params.event)
      .then(function(response) {
        if (response.status) {
          var data = response.data.data;
          var sanctions = rootGetters["competition/getPunishments"](1);
          for (var i in data) {
            data[i].visible = true;
            data[i].sanctions_name =
              data[i].type && data[i].type != "null"
                ? sanctions.filter(sanction => sanction.code == data[i].type)[0]
                    .description
                : "-";
            if (parseInt(data[i].status) == 2) {
              data[i].status_sanction = "Desestimada";
            } else {
              if (data[i].num_match == 0) {
                data[i].status_sanction = "Pendent de confirmar";
              } else if (data[i].num_match == data[i].matches_completed) {
                data[i].status_sanction = "Completada";
              } else {
                data[i].status_sanction = "Confirmada";
              }
            }
          }

          commit("setList", { data: data, total: response.data.total });
          //   return commit("setPagination", page_options);

          //   return commit("setPagination", page_options);
        }
      });
  },

  load_by_id({ commit, dispatch, getters, rootState }, params) {
    return dispatch("competition/loadPhases", params, { root: true }).then(
      function(response) {
        return dispatch(
          "teams/loadList",
          {
            event: rootState.events.current_event.id,
            page_options: { num_page: -1, num_items: -1 },
            filters: { status: "6" }
          },
          { root: true }
        ).then(function() {
          return dispatch("competition/loadTemplTeams", params, {
            root: true
          }).then(function() {
            return dispatch("competition/loadRounds", params, {
              root: true
            }).then(function() {
              return dispatch("facilitys/loadList", params, {
                root: true
              }).then(function() {
                return dispatch("competition/groups/loadList", params, {
                  root: true
                }).then(function() {
                  var path = "competition/match/" + params.id;
                  return api.get(path).then(function(response) {
                    if (response.status) {
                      var data = response.data;

                      return commit("addMatch", data);
                    }
                  });
                });
              });
            });
          });
        });
      }
    );
  },

  editSanction({ commit, dispatch, getters, rootState }, params) {
    return api
      .post(
        "competition/sanctions/" +
          params.id +
          "/event/" +
          params.event_id +
          "/update",
        params.data
      )
      .then(function(response) {
        if (response.status) {
          var data = response.data;

          return commit("addSanction", data);
        }
      });
  },

  desestimar({ commit, dispatch, getters, rootState }, params) {
    return api
      .post(
        "competition/sanctions/" +
          params.id +
          "/event/" +
          params.event_id +
          "/desestimar",
        {}
      )
      .then(function(response) {
        if (response.status) {
          var data = response.data;

          return commit("addSanction", data);
        }
      });
  },

  fetch_punishment_events ({ commit }) {
    var path = 'competition/punishment-events/'
    return api.get(path).then(function (response) {
      if (response.status) {
        var data = response.data
        return commit('savePunishmentEvents', data)
      }
    })
  },

  add_sanction({ commit }, sanctionData) {
    const path = "competition/sanctions/add";
    return api.post(path, sanctionData).then((response) => {
      if (response.status) {
        return response;
      }
    });
  }
};

// mutations
const mutations = {
  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },

  addSanction(state, sanction) {
    var list = { ...state.list };
    list[sanction.id] = sanction;

    state.list = list;
  },

  applyFilters(state, filters) {
    // console.log( "--- CLUBS APPLY FILTERS ---", filters )
    // var list = { ...state.list };
    // if (!filters) {
    //   for (var i in list) {
    //     list[i].visible = true;
    //   }
    // } else {
    //   for (var i in list) {
    //     list[i].visible = false;
    //   }
    //   for (var i in list) {
    //     var item = list[i];
    //     // console.log( " ---- ITEM " + item.name + " --- " );
    //     var bFound = true;
    //     for (var k in filters) {
    //       // console.log( "--- KEY: " + k + " ---" )
    //       if (filters[k] != -1) {
    //         var item_value =
    //           item[k] != null && typeof item[k] == "object"
    //             ? item[k].id
    //             : item[k];
    //         if (
    //           item.hasOwnProperty(k) &&
    //           filters[k] == null &&
    //           item_value == null
    //         ) {
    //         } else {
    //           // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] + " " + typeof filters[k] );
    //           // filters[k] = filters[k] == null ? null : ( typeof filters[k] !== 'string' ? ( typeof filters[k] !== 'boolean' ? ( filters[k] ? 1 : 0 ) : filters[k] ) : filters[k].trim() )

    //           if (filters[k] != null && typeof filters[k] === "boolean")
    //             filters[k] = filters[k] ? 1 : 0;
    //           else if (filters[k] != null && typeof filters[k] === "string")
    //             filters[k] = filters[k].trim();

    //           // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] + " " + typeof filters[k] );
    //           var regexp = new RegExp(filters[k], "gi");

    //           if (
    //             item.hasOwnProperty(k) &&
    //             typeof item[k] == "object" &&
    //             filters[k] != item_value
    //           ) {
    //             bFound = false;
    //           } else if (
    //             item.hasOwnProperty(k) &&
    //             typeof item[k] !== "object" &&
    //             !item_value.match(regexp)
    //           ) {
    //             bFound = false;
    //           }
    //         }
    //       }
    //     }

    //     list[i].visible = bFound;
    //   }
    // }

    // state.list = list;
    state.current_filters = filters;
  },
  setPagination(state, value) {
    state.pagination = value;
  },
  setFirstTime(state, value) {
    state.bFirstTime = value;
  },

  savePunishmentEvents (state, events) {
    state.punishment_events = events
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
